import { configureStore } from '@reduxjs/toolkit';
import blogReducer from '../features/blog/blogSlice';
import blogsReducer from '../features/blogs/blogsSlice';
import filterReducer from '../features/filter/filterSlice';
import relatedBlogsReducer from '../features/relatedBlogs.js/relatedBlogsSlice';

export const store = configureStore({
  reducer: {
    blogs: blogsReducer,
    blog: blogReducer,
    relatedBlogs: relatedBlogsReducer,
    filters: filterReducer,
  },
});
